<template lang="pug">
v-container.report-table.pa-0(fluid)
  v-layout
    v-flex(xs8)
      v-select(
        v-model="category"
        :items="CATEGORY"
        item-value="value"
        item-text="text"
        label="分類顯示"
        outline)    
  v-data-table(
    v-model="selected"
    :headers="headers"
    :items="items"
    :pagination.sync="pagination"
    item-key="temp.id"
    hide-actions)
    template(v-slot:items="props")
      td
        v-btn(
          color="info"
          flat
          small
          icon
          @click="openInfo(props.item)")
          v-icon visibility
      td {{ props.item.payee ? props.item.payee.displayName : props.item.displayName }}
      td {{ props.item.total }}
      td {{ props.item.transferDate | timestampFilter }}
      td {{ props.item.lastFiveNumber || '' }}
      td {{ props.item.bankname || '' }}
  v-layout(v-if="category")
    pagination-loader(
      ref="loader"
      :queryRef="queryRef"
      :limit="15"
      @update="items = $event")
  v-dialog(
    v-model="info"
    hide-overlay
    max-width="500")
    v-toolbar(
      dark
      color="indigo"
      flat)
      v-toolbar-title 回報資料
    v-card
      report-info-director(
        v-if="info && category === 'director'"
        :report="currentReport | clone"
        @cancel="closeInfo"
        @settle-succeed="settleSucceed")
      report-info-user(
        v-if="info && category === 'user'"
        :report="currentReport | clone"
        @cancel="closeInfo"
        @settle-succeed="settleSucceed")
</template>

<script>
import { mapGetters } from "vuex";
import { db } from "@/firebase";
import ReportInfoDirector from "@/components/ReportInfoDirector.vue";
import ReportInfoUser from "@/components/ReportInfoUser.vue";
import PaginationLoader from "@/components/core/PaginationLoader.vue";

const CATEGORY = [
  { value: "director", text: "主委上繳" },
  { value: "user", text: "用戶自繳" }
];

const dataHeaders = [
  { text: "查看", value: "read" },
  { text: "繳交者", value: "payee" },
  { text: "繳交總額", value: "total" },
  { text: "匯款時間", value: "transferDate" },
  { text: "帳號後5碼", value: "lastFiveNumber" },
  { text: "銀行名稱", value: "bankname" }
];

export default {
  name: "ReportTable",
  components: {
    ReportInfoDirector,
    ReportInfoUser,
    PaginationLoader
  },
  data() {
    return {
      CATEGORY,
      pagination: {
        rowsPerPage: -1,
        sortBy: "creationTime",
        descending: true
      },
      queryRef: {},
      category: null,
      selected: [],
      items: [],
      info: false,
      disableForm: false,
      settleForm: false,
      reportForm: false,
      currentReport: null
    };
  },
  computed: {
    ...mapGetters("auth", ["uid", "role"]),
    headers() {
      const list = [];
      if (this.settleAction) list.push(this.settleAction);
      if (this.reportAction) list.push(this.reportAction);
      if (this.disableAction) list.push(this.disableAction);
      return list.concat(dataHeaders);
    }
  },
  watch: {
    category(v) {
      switch (v) {
        case "director":
          this.queryRef = db
            .collection("directorReports")
            .orderBy("creationTime", "desc");
          break;
        case "user":
          this.queryRef = db
            .collection("userReports")
            .orderBy("creationTime", "desc");
          break;
        default:
          this.queryRef = db
            .collection("directorReports")
            .orderBy("creationTime", "desc");
      }
    },
    selected: {
      handler: function(selected) {
        this.$emit("update-selected", selected);
      },
      immediate: true
    }
  },
  methods: {
    openInfo(report) {
      this.currentReport = report;
      this.info = true;
    },
    closeInfo() {
      this.currentReport = null;
      this.info = false;
    },
    async settleSucceed() {
      await this.$refs.loader.reload();
      this.selected = [];
      this.info = false;
    }
  }
};
</script>
